import {Component, Input, OnInit} from '@angular/core';
import {OptionService} from "../option/option.service";
import {HttpClient} from "@angular/common/http";

@Component({
  selector: 'project-progress',
  templateUrl: './output.progress.component.html'
})
export class ProgressComponent implements OnInit {

  /**
   * current size of the widget
   */
  @Input() size: string;

  /**
   * toggle for showing the project target
   */
  showTarget = false;

  /**
   * toggle for showing the project stand
   */
  showStand = false;

  /**
   * toggle to show/hide the number of donors
   */
  showDonors = true;

  /**
   * donation target of the project
   * @type {any}
   */
  target: string = null;

  /**
   * reached percentage of the target
   * @type {number}
   */
  percentage: number = null;

  /**
   * amount that is already donated in this project
   * @type {number}
   */
  amount: number = null;

  /**
   * Number of donators in this project
   * @type {number}
   */
  donators: number = null;

  /**
   * Symbol for the current currency
   * @type {any}
   */
  currencySymbol: string = null;

  /**
   * toggle for either showing the money value of the percentage value (default = percentage)
   */
  showMoneyValue = false;

  /**
   * constructore
   * @param optionService
   * @param http
   */
  constructor(private optionService: OptionService, private http: HttpClient) {}

  /**
   * Initialize the view
   */
  public ngOnInit(): any {
    // get the activated version
    this.showTarget = this.optionService.hasProjectTarget();
    this.showStand = this.optionService.getOption('has_donation_stand');

    // get the currency
    this.currencySymbol = this.optionService.getOrganisationData("currency");

    // should we show the project target?
    if (this.showTarget === true) {
      const projectTargetPercentage: number = this.optionService.getProjectTargetPercentage()

      this.amount = this.optionService.getProjectTargetAmount();
      this.target = this.optionService.getProjectTarget() + "";
      this.percentage = projectTargetPercentage && projectTargetPercentage > 0 ? projectTargetPercentage : 0;
      this.donators = this.optionService.getProjectTargetDonators();
      this.showMoneyValue = this.optionService.getOption('has_projecttarget_as_money');
      this.showDonors = !this.optionService.getOption('has_hide_projecttarget_donations');
    }
    else if (this.showStand) {
      // get the current amount
      this.amount = this.optionService.getProjectTargetAmount();
    }
    else {
      // do nothing
      return;
    }

    // get an update of the donation amount
    const updateUrl = this.optionService.getProjectTargetUpdateUrl();
    if (updateUrl) {
      this.http.get(updateUrl).subscribe(data => {
        if (data && data.hasOwnProperty("amount")) {
          this.amount = data["amount"];

          if (this.showTarget === true) {
            this.target = data["target"];
            this.percentage = data["percentage"];
            this.donators = data["donators"];
          }
        }
      }, error => {
        console.warn('Could not get update of project data, ignore this.', error);
      });
    }
  }
}
